export default "__VITE_ASSET__Ldklvs6h__"